import { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { useTranslation } from 'react-i18next'

// local imports
import calendarLoading from 'assets/icons/loading-calendar.png'
import MeetingRoomService from 'service/MeetingRoomService'
import Loader from 'components/ui/Loader'
import { ImgPreviewWrapper } from './styled'

interface ComponentProps {
  roomId: number
  open: boolean
  handleClose: () => void
}

export default function ImgPreviewModal({ roomId, open, handleClose }: ComponentProps) {
  const { t } = useTranslation()
  const [src, setSrc] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getImage = () => {
      setLoading(true)
      MeetingRoomService.getMeetingRoomImage(roomId)
        .then((r) => setSrc(r.data))
        .catch((e) => console.log(e))
        .finally(() => setLoading(false))
    }

    getImage()
  }, [roomId])

  return (
    <Dialog
      id="meetingRoomImgPreview"
      blockScroll
      keepInViewport
      closeOnEscape={false}
      focusOnShow={false}
      closable={true}
      header={<span>{t('meeting-res-modal.img-preview-title')}</span>}
      draggable={false}
      resizable={false}
      visible={open}
      style={{ width: '85vw', height: '85vh' }}
      //   breakpoints={{ '1536px': '75vw', '1280': '75vw' }}
      onHide={handleClose}>
      <ImgPreviewWrapper>
        {loading ? (
          <ListLoader />
        ) : (
          <img
            src={`data:image;base64,${src}`}
            alt="meeting-room-template"
            style={{ maxWidth: '95%', maxHeight: '100%', objectFit: 'contain', borderRadius: '12px' }}
          />
        )}
      </ImgPreviewWrapper>
    </Dialog>
  )
}

function ListLoader() {
  return (
    <div className="py-5 my-4">
      <Loader src={calendarLoading} />
    </div>
  )
}
